import { environment } from '../../../environments/environment';

export const API = {
  RECOMMENDATIONS: `${environment.mockApiUrl}/categories`,
  TRACKS: `${environment.apiUrl}/spotify_api/v1/tracks`,
  FAVORITE: `${environment.pptlApi}/channel/v2/deliveries/inbox/favorites`,
  DELIVERY: `${environment.pptlApi}/channel/v1/delivery`,
  DELIVERIES_MOCK_ASSET: `${environment.mockApiUrl}/asset-deliveries`,
  DELIVERIES_ASSET: `${environment.pptlApi}/channel/v1/delivery`,
  SHARE_DELIVERY: `${environment.pptlApi}/channel/v1/delivery/share`,
  GET_SHARE_DELIVERY_REASONS: `${environment.pptlApi}/channel/v1/delivery/getAllSharedReason`,
  DELIVERIES_DOWNLOAD: `${environment.pptlApi}/media/v1/download/dwl`,
  ASPERA_DOWNLOAD_ALL: `${environment.pptlApi}/media/v1/aspera/downloadAll`,
  INBOX: `${environment.pptlApi}/channel/v2/deliveries/inbox`,
  INBOX_REACTIVATE: `${environment.pptlApi}/channel/v1/deliveries/inbox/resend`,
  INBOX_COUNT: `${environment.pptlApi}/channel/v1/deliveries/inbox/count`,
  INBOX_SEARCH: `${environment.pptlApi}/channel/v1/inbox/search/`,
  INBOX_MOCK: `${environment.pptlApi}/channel/v1/mock/deliveries/inbox`,
  SEARCH: `${environment.mockApiUrl}/deliveries/search`,
  CURRENT_USER: `${environment.mockApiUrl}/user/current`,
  AUTH: `${environment.pptlApi}/auth`,
  GET_ACCESS_TOKEN: `${environment.pptlApi}/auth/getAccessToken`,
  SIGN_UP: `${environment.pptlApi}/pum/v1/users/signup`,
  FORGOT_PASSWORD: `${environment.pptlApi}/pum/v1/users/forgotPassword`,
  VALIDATION_APP_VERSION: `${environment.pptlApi}/pum/v1/users/validateAppVersion`,
  RESET_PASSWORD: `${environment.pptlApi}/pum/v1/users/resetPassword`,
  VERIFY_USER: `${environment.pptlApi}/pum/v1/users/verifyUser`,
  LOGOUT: `${environment.pptlApi}/auth/portal/logout`,
  CHANGE_PASSWORD: `${environment.pptlApi}/pum/v1/users/changePassword`,
  USER_SETTINGS: `${environment.pptlApi}/pum/v1/userSettings`,
  USER_SETTINGS_INFO: `${environment.pptlApi}/pum/v1/userSettings/userSettingsInfo`,
  OFFLINE_CACHE_SIZE: `${environment.pptlApi}/pum/v1/userSettings/getAllOfflineCacheSizes`,
  UPDATE_CACHE_SIZE: `${environment.pptlApi}/pum/v1/userSettings/updateOfflineCacheSize`,
  UPDATE_USER_INFO: `${environment.pptlApi}/pum/v1/users/updateUserInformation`,
  UPDATE_USER_NOTIFICATION: `${environment.pptlApi}/pum/v1/userSettings/updateUserNotification`,
  UPDATE_OFFLINE_EVENT: `${environment.pptlApi}/media/v1/offline/updateevent/`,
  UPDATE_FIREBASE_TOKEN: `${environment.pptlApi}/channel/v1/firebase/token`,
};

export const DATE_TYPES = {
  FORMAT: 'MM-DD-YYYY hh:mm',
  ZONE: 'EST',
  FULL_DATE_FORMAT: 'MM-DD-YYYY hh:mm::ss.SSS',
};

export const VALIDATION_REGEXP = {
  // NAME:
  // allow any character except: multiple spaces.
  // String can't start or end with space symbol
  NAME: /^(?!\s)(?!.*\s$)(?!.*[ ]{2}).{3,}$/,
  HAS_EMPTY_CHAR: /[\s]/,
  AT_LEAST_ONE_LETTER: /^.*[a-zA-Z].*$/,
  // eslint-disable-next-line
  SIMPLE_EMAIL: /^\s*\w+([!#$%&'*+-\/=?^_`{|}~]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*\s*$/,
};
